"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSweepstakesFreeEntryMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const buildSweepstakesFreeEntryMockData = ({ orgName, sweepstakesTitle, color, isDarkMode, firstName = "Jordan", entryNumbers = [147, 148, 149], entriesUrl, locale = "en", }) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    return {
        labels,
        theme,
        iconZeffyLogo: theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
        lang: locale,
        subject: labels.sweepstakesFreeEntriesConfirmed,
        orgName,
        firstName,
        sweepstakesTitle,
        entries: entryNumbers.map((number) => ({ number })),
        entriesUrl,
    };
};
exports.buildSweepstakesFreeEntryMockData = buildSweepstakesFreeEntryMockData;
